import axios, { AxiosResponse } from 'axios';

import { API_SEND_HIT } from '../urls';
import { safeLocalStorage, safeSessionStorage } from '../../../../helpers/utils/safeStorage';

const isAllowed = (): boolean => {
  const token =
    safeLocalStorage.getItem('access') || safeSessionStorage.getItem('access');
  return !!token;
};

const buildHitData = (hit: string, location: string, type: number) => {
  const sanitizedLocation = new URL(location).toString();
  return {
    type: Number(type),
    url: sanitizedLocation,
    hit: hit.replace(/[^a-zA-Z0-9-]/g, ''),
  };
};

export const logsApi = {
  sendHit: (
    hit: string,
    location: string,
    type: number
  ): Promise<AxiosResponse | void> | undefined => {
    try {
      if (!isAllowed()) {
        return;
      }

      const data = buildHitData(hit, location, type);

      return axios
        .post(API_SEND_HIT, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .catch(() => {});
    } catch (error) {
      console.error(
        'Hit logging error:',
        error instanceof Error ? error.message : 'Unknown error'
      );
      return;
    }
  },

  sendBeaconHit: (hit: string, location: string, type: number): void => {
    try {
      if (!isAllowed()) {
        return;
      }

      const data = buildHitData(hit, location, type);
      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      navigator.sendBeacon(API_SEND_HIT, blob);
    } catch (error) {
      // sendBeacon вызывается при закрытии вкладки — ошибки не критичны
    }
  },
};
